import { createContext } from 'react';
import { AuthContextType } from '@/types/generals';

const UserContext = createContext<AuthContextType>({
  user: null,
  signOut: () => {},
  error: null,
  permissions: [],
  hasPermission: () => ({
    canRead: false,
    canWrite: false,
    noScreen: true,
  }),
  loading: true,
});

export default UserContext;